module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"changePlan":"You can cancel your subscription or change the payment period","changePlanLink":"here"}}')
  delete Component.options._Ctor
}
